import { Fragment, FC, MutableRefObject } from "react"
import { BlurEventType, ChangeInputType } from "../../api/EventTypes"
import { LoginContent } from "../../common/pageText"
import Input from "../../components/generic/form/Input"

export interface IErrors {
  [key: string]: string
}

export interface IFormProps {
  value: {
    [key: string]: any
  }
  onChange: (e: ChangeInputType) => void
  onBlur: (e: BlurEventType) => void
  inputRef?: MutableRefObject<HTMLInputElement>
  errors?: IErrors
}
const LoginForm: FC<IFormProps> = ({ value, onChange, onBlur, errors }) => {
  return (
    <Fragment>
      <Input
        value={value.username}
        name="username"
        onChange={onChange}
        inputIdentifier="username"
        onBlur={onBlur}
        label={LoginContent.username}
        autoFocus
        error={errors.username}
      />

      <Input
        type="password"
        value={value.password}
        name="password"
        onChange={onChange}
        inputIdentifier="password"
        onBlur={onBlur}
        label={LoginContent.password}
        error={errors.password}
      />
    </Fragment>
  )
}

export default LoginForm
